import { generateTestId } from "@client-shared";

export const setAppSidebarTestId = (identifier: string): string => generateTestId("AppSidebar", identifier);

export const setAppSidebarNavItemTestId = (name: string): string =>
  generateTestId("AppSidebar", `nav-${name.toLowerCase().replace(/\s+/g, "-")}`);
